import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import moment from 'moment/moment';
import Button from 'components/CustomButton';
import Error from 'components/ErrorMessage';
import UserInfo from '../../../Userinfo/index';
import styles from './UpgradeStudent.scss';

const plans = [
  {
    title: '1 Month',
    noOfMonths: 1,
    planName: '29_99_once_1_month',
  },
  {
    title: '3 Month',
    noOfMonths: 3,
    planName: '19_99_per_month_3_months',
  },
  {
    title: '6 Month',
    noOfMonths: 6,
    planName: '75_once_6_months',
  },
  {
    title: '12 Month',
    noOfMonths: 12,
    planName: '99_once_12_months',
  },
  {
    title: 'Life Time',
    noOfMonths: 12000,
    planName: '199_once_lifetime',
  },

];
// to import local scss fle

class UpgradeStudent extends Component {
  static propTypes = {
    userInfo: PropTypes.shape.isRequired,
    setTabToInitial: PropTypes.func.isRequired,
    upgradeStudent: PropTypes.func.isRequired,
    upgradeInfo: PropTypes.shape.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      planIndex: null,
      selectedPlan: {},
    };
  }

  handlePlanChange = (index, item) => {
    this.setState({ planIndex: index, selectedPlan: item });
  };

  upgradeStudent = () => {
    const { selectedPlan } = this.state;
    const expiryDate = new Date();
    const month = expiryDate.getMonth() + selectedPlan.noOfMonths;
    const lastdate = moment(expiryDate);
    lastdate.add(month, 'month');
    const d =  lastdate._d; // eslint-disable-line
    const transactiondate = new Date().toISOString();

    const payment = {
      last_date: d,
      payment_customer_id: 'free_access_customer_id',
      transaction_id: 'free_access_transaction_id',
      payment_status: true,
      plan_id: selectedPlan.planName,
      transaction_date: transactiondate,
    };
    const payload = {
      student_id: this.props.userInfo.student_id,
      payment_info: [payment],
    };
    this.props.upgradeStudent(payload);
  };

  render() {
    const { userInfo, setTabToInitial, upgradeInfo } = this.props;
    const { planIndex, selectedPlan } = this.state;
    const renderUserNotSelected = renderIf(userInfo.name === undefined);
    const renderUserSelected = renderIf(userInfo.name !== undefined && !upgradeInfo);
    const renderSuccessMessage = renderIf(upgradeInfo === true && userInfo.name !== undefined);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderUserNotSelected(<Error message="Please select user in first tab" />)}
        {renderUserSelected(
          <div className={cn('col s12', styles.container)}>
            <UserInfo userInfo={userInfo} userType="STUDENT" /><br />
            <div className={cn('col s12', styles.actionContainer)}>
              <span className={styles.selectPlan}>Select plan.</span> <br />
            </div>
            {plans.map((item, i) => (
              <button
                className={planIndex === i ? styles.selectedButton : styles.plainButton}
                onClick={() => this.handlePlanChange(i, item)}
              >
                {item.title}
              </button>
            ))}
          </div>)}
        {renderUserSelected(<Button label="UPGRADE USER" style={styles.buttonContainer} onClick={this.upgradeStudent} />)}
        {renderUserNotSelected(<Button label="SELECT USER" style={styles.buttonContainer} onClick={setTabToInitial} />)}
        {renderSuccessMessage(
          <span className={styles.successMessage}>
            User is upgraded with {selectedPlan.title} plan!
          </span>,
        )}
      </div>
    );
  }
}

export default UpgradeStudent;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/StudentView/components/UpgradeStudent/View.js